import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Add Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';

import { FeatureFlagsAdminComponent } from './components/feature-flags-admin.component';
import { FeatureFlagsListComponent } from './components/list/feature-flags-list.component';
import { FeatureFlagDetailComponent } from './components/detail/feature-flag-detail.component';
import { FeatureFlagFormComponent } from './components/form/feature-flag-form.component';
import { BooleanRuleComponent } from './components/rule-builder/boolean-rule.component';
import { EmailRuleComponent } from './components/rule-builder/email-rule.component';
import { UserGroupRuleComponent } from './components/rule-builder/user-group-rule.component';
import { UserRoleRuleComponent } from './components/rule-builder/user-role-rule.component';
import { RegionRuleComponent } from './components/rule-builder/region-rule.component';
import { LineOfBusinessRuleComponent } from './components/rule-builder/line-of-business-rule.component';
import { GroupRuleComponent } from './components/rule-builder/group-rule.component';

import { FeatureFlagsAdminService } from './services/feature-flags-admin.service';

@NgModule({
  declarations: [
    FeatureFlagsAdminComponent,
    FeatureFlagsListComponent,
    FeatureFlagDetailComponent,
    FeatureFlagFormComponent,
    BooleanRuleComponent,
    EmailRuleComponent,
    UserGroupRuleComponent,
    UserRoleRuleComponent,
    RegionRuleComponent,
    LineOfBusinessRuleComponent,
    GroupRuleComponent,
  ],
  exports: [FeatureFlagsAdminComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
  ],
  providers: [FeatureFlagsAdminService, provideHttpClient(withInterceptorsFromDi())],
})
export class FeatureFlagsAdminModule {}
